const CategoryHeader = ({ title, subtitle, isDarkMode, image }) => {
  return (
      <div className="flex items-center mb-3">
        {image && <img src={image} className="object-contain w-10 h-10 mr-3 rounded-[5px]" />}
        <div>
          <h2
            className={`text-sm sm:text-base md:text-lg font-semibold ${
              isDarkMode ? "text-white" : "text-gray-800"
            }`}
          >
            {title}
          </h2>
          <p
            className={`text-[9px] sm:text-[11px] ${
              isDarkMode ? "text-gray-400" : "text-gray-500"
            }`}
          >
            {subtitle}
          </p>
        </div>
      </div>
  );
};

export default CategoryHeader;
